import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ReceitaCliente({ register }) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-200 pb-2 mb-4">Dados do Cliente</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="space-y-2">
          <Label htmlFor="nome_cliente" className="text-sm font-medium text-slate-700">Nome do Cliente</Label>
          <Input id="nome_cliente" {...register("nome_cliente")} placeholder="Nome completo" data-testid="input-nome-cliente" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cpf_cliente" className="text-sm font-medium text-slate-700">CPF</Label>
          <Input id="cpf_cliente" {...register("cpf_cliente")} placeholder="000.000.000-00" data-testid="input-cpf-cliente" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="telefone_cliente" className="text-sm font-medium text-slate-700">Telefone</Label>
          <Input id="telefone_cliente" {...register("telefone_cliente")} placeholder="(00) 00000-0000" data-testid="input-telefone-cliente" />
        </div>
      </div>
    </div>
  );
}
